/**
 * Formats a chart tooltip value for display.
 *
 * Numbers round to at most one decimal place with trailing `.0` dropped
 * (`53.666…` → `53.7`, `83` → `83`). Strings pass through unchanged.
 *
 * @param value - Raw ECharts series value (number or string).
 * @returns A short display string suitable for a tooltip line.
 */
export function formatChartTooltipValue(value: number | string): string {
  if (typeof value === 'string') {
    return value;
  }

  if (!Number.isFinite(value)) {
    return String(value);
  }

  const rounded = Math.round(value * 10) / 10;
  return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1);
}
